import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';

@Entity('migrations')
export class MigrationsEntity {
	@PrimaryGeneratedColumn()
	public id!: number;

	@Column('bigint', { name: 'timestamp' })
	public timestamp!: string;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;
}
